import React from "react";

import icon_citrus from "../images/ico-citrus.png";
import icon_dex from "../images/ico-dex.png";
// import icon_zendu from '../images/ico-zendu.png';
// import icon_ntfy from '../images/ico-ntfy.png';
import icon_twf from "../images/ico-twf.png";
import icon_igf from "../images/ico-igf.png";
import icon_cntu from "../images/ico-cntu.png";
import icon_dieetclub from "../images/ico-dieetclub.png";
import icon_ghostin from "../images/ico-ghostin.png";
import icon_inflow from "../images/ico-inflow.png";

const e = React.createElement;

function CompanyFooter() {}
CompanyFooter.prototype = Object.create(React.Component.prototype);

CompanyFooter.prototype.render = function () {
  var text_more = "Meer van Polymedia";
  var text_projectby = " is een project van Polymedia.";
  if (this.props.lang === "EN") {
    text_more = "More by Polymedia";
    text_projectby = " is a project by Polymedia.";
  }
  var more = [
    e("li", { key: "2121" }, [
      e(
        "span",
        { key: "21211" },
        e("img", { src: icon_twf, alt: "Twitter Feed+" })
      ),
      e(
        "a",
        {
          href: "https://dashboard.twitch.tv/extensions/dy9or3jkex4hkrfm6nhsww2821g8eu",
          key: "21212",
          target: "_blank",
          rel: "noopener noreferrer",
        },
        "Twitter Feed+"
      ),
    ]),
    e("li", { key: "2122" }, [
      e(
        "span",
        { key: "21221" },
        e("img", { src: icon_igf, alt: "Instagram Feed+" })
      ),
      e(
        "a",
        {
          href: "https://dashboard.twitch.tv/extensions/h0ije9m9fnhw3oc1sxtqiba8bspci2",
          key: "21222",
          target: "_blank",
          rel: "noopener noreferrer",
        },
        "Instagram Feed+"
      ),
    ]),
    e("li", { key: "2123" }, [
      e(
        "span",
        { key: "21231" },
        e("img", { src: icon_cntu, alt: "Content Unlock" })
      ),
      e(
        "a",
        {
          href: "https://dashboard.twitch.tv/extensions/dlf6q6n5woft819zzvn0eamkf950v2",
          key: "21232",
          target: "_blank",
          rel: "noopener noreferrer",
        },
        "Content Unlock"
      ),
    ]),
  ];
  // if(this.props.site === "Zendu") {
  //   delete more[0];
  // } else if(this.props.site === "Citrus") {
  //   delete more[1];
  // }
  var dieetclub_url = "https://dieet.club";
  var citrus_url = "https://citrus.polymedia.nl";
  var dex_url = "https://dex.polymedia.nl";
  var ghostin_url = "https://ghostin.nl";
  var inflow_url = "https://inflow.polymedia.nl";
  if (this.props.lang === "EN") citrus_url = "https://citrus.polymedia.nl/en";
  if (this.props.site === "Citrus") {
    delete more[2];
    more.unshift(
      e("li", { key: "2120" }, [
        e(
          "span",
          { key: "21201" },
          e("img", { src: icon_dieetclub, alt: "Dieet.Club" })
        ),
        e(
          "a",
          {
            href: dieetclub_url,
            key: "21211",
            target: "_blank",
            rel: "noopener noreferrer",
          },
          "Dieet.Club"
        ),
      ])
    );
  } else if (this.props.site === "DEX") {
    delete more[2];
    more.unshift(
      e("li", { key: "2120" }, [
        e(
          "span",
          { key: "21201" },
          e("img", { src: icon_citrus, alt: "Citrus by Polymedia" })
        ),
        e(
          "a",
          {
            href: citrus_url,
            key: "21211",
            target: "_blank",
            rel: "noopener noreferrer",
          },
          "Citrus by Polymedia"
        ),
      ])
    );
  } else if (
    this.props.site === "INFLOW" ||
    this.props.site === "OXU" ||
    this.props.site === "Meute" ||
    this.props.site === "D2B.shop" ||
    this.props.site === "Ghostin" ||
    this.props.site === "Dieet.Club"
  ) {
    more = [
      e("li", { key: "2121" }, [
        e(
          "span",
          { key: "21211" },
          e("img", { src: icon_citrus, alt: "Citrus by Polymedia" })
        ),
        e(
          "a",
          {
            href: citrus_url,
            key: "21212",
            target: "_blank",
            rel: "noopener noreferrer",
          },
          "Citrus by Polymedia"
        ),
      ]),
      e("li", { key: "2122" }, [
        e(
          "span",
          { key: "21221" },
          e("img", { src: icon_dex, alt: "DEX by Polymedia" })
        ),
        e(
          "a",
          {
            href: dex_url,
            key: "21222",
            target: "_blank",
            rel: "noopener noreferrer",
          },
          "DEX by Polymedia"
        ),
      ]),
      e("li", { key: "2123" }, [
        e(
          "span",
          { key: "21231" },
          e("img", { src: icon_dieetclub, alt: "Dieet.Club" })
        ),
        e(
          "a",
          {
            href: dieetclub_url,
            key: "21232",
            target: "_blank",
            rel: "noopener noreferrer",
          },
          "Dieet.Club"
        ),
      ]),
    ];
    if (this.props.site === "INFLOW") {
      more.unshift(
        e("li", { key: "2120" }, [
          e(
            "span",
            { key: "21201" },
            e("img", { src: icon_ghostin, alt: "Ghostin.nl" })
          ),
          e(
            "a",
            {
              href: ghostin_url,
              key: "21211",
              target: "_blank",
              rel: "noopener noreferrer",
            },
            "Ghostin.nl"
          ),
        ])
      );
    }
    if (this.props.site === "Ghostin") {
      more.unshift(
        e("li", { key: "2120" }, [
          e(
            "span",
            { key: "21201" },
            e("img", { src: icon_inflow, alt: "INFLOW Marketing Bureau" })
          ),
          e(
            "a",
            {
              href: inflow_url,
              key: "21211",
              target: "_blank",
              rel: "noopener noreferrer",
            },
            "INFLOW Marketing Bureau"
          ),
        ])
      );
    }
    if (this.props.site === "Dieet.Club") {
      more.unshift(
        e("li", { key: "2120" }, [
          e(
            "span",
            { key: "21201" },
            e("img", { src: icon_inflow, alt: "INFLOW Marketing Bureau" })
          ),
          e(
            "a",
            {
              href: inflow_url,
              key: "21211",
              target: "_blank",
              rel: "noopener noreferrer",
            },
            "INFLOW Marketing Bureau"
          ),
        ])
      );
      more.unshift(
        e("li", { key: "2120" }, [
          e(
            "span",
            { key: "21201" },
            e("img", { src: icon_ghostin, alt: "Ghostin.nl" })
          ),
          e(
            "a",
            {
              href: ghostin_url,
              key: "21211",
              target: "_blank",
              rel: "noopener noreferrer",
            },
            "Ghostin.nl"
          ),
        ])
      );
      more.pop();
    }
  }
  var first_col = e("div", { key: "21", className: "col-3" }, [
    e("h2", { key: "211" }, text_more),
    e("ul", { key: "212", className: "more-polymedia" }, more),
  ]);
  if (this.props.custom_first_col !== undefined) {
    first_col = this.props.custom_first_col;
  }
  var sitemap = [];
  var si = 0;
  for (var sitemap_title in this.props.sitemap) {
    si++;
    var sa = this.props.sitemap[sitemap_title];
    var st = sitemap_title;
    if (sa === "/") {
      sitemap.push(e("li", { key: "222" + si }, e("a", { href: "/" }, st)));
    } else {
      sitemap.push(e("li", { key: "222" + si }, e("a", { href: sa }, st)));
    }
  }
  var address1 = "",
    address2 = "",
    address3 = "",
    address4 = "";
  if (this.props.ignore_address === undefined) {
    var linkedin = "https://www.linkedin.com/in/peterdotplus/";
    if (this.props.linkedin !== undefined) linkedin = this.props.linkedin;
    address1 = e(
      "p",
      { key: "234" },
      e(
        "a",
        { href: linkedin, target: "_blank", rel: "noopener noreferrer" },
        "LinkedIn"
      )
    );
    if (this.props.site !== "Ghostin")
      address3 = e(
        "p",
        { key: "2345" },
        e(
          "a",
          {
            href: "https://x.com/PolymediaNL",
            target: "_blank",
            rel: "noopener noreferrer",
          },
          "X.com"
        )
      );
    if (this.props.site === "Ghostin")
      address3 = e(
        "p",
        { key: "2345" },
        e(
          "a",
          {
            href: "https://polymedia.nl",
            target: "_blank",
            rel: "noopener noreferrer",
          },
          "Polymedia.nl"
        )
      );
    if (this.props.site === "INFLOW")
      address4 = e(
        "p",
        { key: "2346" },
        e(
          "a",
          {
            href: "https://bsky.app/profile/peter-inflow.bsky.social",
            target: "_blank",
            rel: "noopener noreferrer",
          },
          "Bluesky"
        )
      );
    address2 = e("p", { key: "235" }, "KvK: 78301629");
  }

  return e(
    "footer",
    { className: "polymedia-footer" },
    e("div", { key: "1", className: "wrap" }, [
      first_col,
      e("div", { key: "22", className: "col-3" }, [
        e("h2", { key: "221" }, this.props.site),
        e("ul", { key: "222" }, sitemap),
      ]),
      e("div", { key: "23", className: "col-3" }, [
        e(
          "h2",
          { key: "231" },
          e(
            "a",
            {
              href: "https://polymedia.nl",
              target: "_blank",
              rel: "noopener noreferrer",
            },
            "Polymedia.nl"
          )
        ),
        e("p", { key: "232" }, this.props.site + text_projectby),
        address1,
        address4,
        address3,
        address2,
      ]),
    ])
  );
};

export default CompanyFooter;



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/Company_Footer.js
// module id = 204
// module chunks = 0